module.exports = __webpack_public_path__ + "img/DE03000.ab74ab5f.png";